import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sokepolicy',
  templateUrl: './sokepolicy.component.html',
  styleUrls: ['./sokepolicy.component.scss']
})
export class SokepolicyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
